/*
 * -----------------------------------------------------------------------
 *  <copyright file="grid-menu.interface.ts" company="Triumph Research Intelligence">
 *      Copyright (C) 2023 by Triumph Research Intelligence. All rights reserved.
 *  </copyright>
 * -----------------------------------------------------------------------
 */

import { IconProp } from '@fortawesome/fontawesome-svg-core';
import React from 'react';
import { UseBoolean } from 'react-hanger';
import { IActionItemV2 } from '../../expandable/grid-v2/interfaces-v2/grid-props-v2.interface';
import { IFilterItem } from '../grid-header.interface';

export enum ExtraMenuItemPosition {
    left = 'left',
    right = 'right',
    expandMenu = 'expand-menu',
}

export interface ExtraMenuItem {
    position?: ExtraMenuItemPosition;
    tooltipTitle?: string;
    onClick?: () => void;
    icon?: IconProp | React.ReactNode;
    disabled?: boolean;
    customClassName?: string;
    expandMenuItems?: IActionItemV2[];
    testId?: string;
}

export interface GridMenuProps {
    settingsMenu?: React.ReactNode;
    switchMenu?: React.ReactNode;
    extraMenuItems: ExtraMenuItem[] | undefined;
    disableExpandMenu?: boolean;
    appliedFilters?: IFilterItem[];
    clearFilters?: () => void;
    viewOptionsMenu?: React.ReactNode;
    checkedRows?: any[];
    hideDeletedToggle?: boolean;
    showDeletedItems?: UseBoolean;
    showExport?: boolean;
    exportCallback?: () => void;
    hideFilter?: boolean;
}
